import { PRODUCT_TYPES } from '../lib/constants';
// ---- internal imports ------

import ProductSalesLogBuilder from './product-sales-log';
// ---- local imports ------

class SalesLog {
	constructor(tableSalesLog, chairSalesLog, couchSalesLog) {
		this.tableSalesLog = tableSalesLog;
		this.chairSalesLog = chairSalesLog;
		this.couchSalesLog = couchSalesLog;
	}

	toPlainObj() {
		return {
			[PRODUCT_TYPES.TABLE]: this.tableSalesLog.toPlainObj(),
			[PRODUCT_TYPES.CHAIR]: this.chairSalesLog.toPlainObj(),
			[PRODUCT_TYPES.COUCH]: this.couchSalesLog.toPlainObj()
		};
	}
};

export default function SalesLogBuilder() {
	return {
		withTableSalesLog: function (amount, price) {
			this.tableSalesLog = new ProductSalesLogBuilder()
				.withAmount(amount)
				.withPrice(price)
				.build();
			return this;
		},
		withChairSalesLog: function (amount, price) {
			this.chairSalesLog = new ProductSalesLogBuilder()
				.withAmount(amount)
				.withPrice(price)
				.build();
			return this;
		},
		withCouchSalesLog: function (amount, price) {
			this.couchSalesLog = new ProductSalesLogBuilder()
				.withAmount(amount)
				.withPrice(price)
				.build();
			return this;
		},
		build: function () {
			return new SalesLog(this.tableSalesLog, this.chairSalesLog, this.couchSalesLog);
		}
	};
}

export function getNewEmptySalesLogObj() {
	return new SalesLogBuilder()
		.withTableSalesLog(0, 0)
		.withChairSalesLog(0, 0)
		.withCouchSalesLog(0, 0)
		.build()
		.toPlainObj();
}
